import { createModuleContext } from '@rebuild/utils/moduleContext';

const MODULE_NAME = 'announcement';

function buildBaseCtx() {
	return {
		languageType: {},
		tabContent: []
	};
}

const { provide: provideCurrentContext, use: useCurrentContext } = createModuleContext(MODULE_NAME, buildBaseCtx);

export { provideCurrentContext, useCurrentContext };
